module.exports = __webpack_public_path__ + "img/113.4408e2af.jpg";